(ns hypnos.backoffice.panel.error
  "Error panel for the backOffice application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The error panel/modal"
  []
  (let [error (rf/subscribe [:backoffice/error])]
    [:div#error.modal {:class (when (:type @error) "is-active")}
     [:div.modal-background
      {:on-click (fn [_] (rf/dispatch [:backoffice/clear-error]))}]
     [:div.modal-card
      [:header.modal-card-head
       [:p.modal-card-title "Error"]
       [:button.delete
        {:aria-label "close"
         :on-click (fn [_] (rf/dispatch [:backoffice/clear-error]))}]]
      [:section.modal-card-body
       [:div.content
        [:h3 "Patient not found"]
        [:p "The patient could not be found, please ..."]]]
      [:footer.modal-card-foot
       [:button.button
        {:on-click (fn [_] (rf/dispatch [:backoffice/clear-error]))}
        "Close"]]]]))
